import { CollectEvent } from 'game/core'
import { EventUI } from "game/extended/uis/events/EventUI"

export const collect_event_ui: EventUI<'CollectEvent'> = {
    model: CollectEvent,

    render: (event: CollectEvent, UI) => null
}
